import IGImg from "./IGImg";

const LogoOrTitle = ({
  logo,
  title,
  className,
  logoClassName,
  titleClassName,
  useImageProxy = true,
}) => {
  return logo ? (
    <IGImg 
      className={`${className} ${logoClassName}`} 
      src={logo} 
      alt={title}
      useImageProxy={useImageProxy}
    />
  ) : (
    <h2 className={`${className} ${titleClassName} text-center`}>{title}</h2>
  );
};

export default LogoOrTitle;
